import type { SVGProps } from 'react';

const SvgLearning = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="learning">
      <path d="M28.72 1h-22A2.81 2.81 0 0 0 3.9 3.77v4.55h1.5V3.77a1.32 1.32 0 0 1 1.32-1.31h22A1.32 1.32 0 0 1 30 3.77v24.46a1.32 1.32 0 0 1-1.32 1.31h-22a1.32 1.32 0 0 1-1.28-1.31v-8.29H3.9v8.29A2.81 2.81 0 0 0 6.72 31h22a2.81 2.81 0 0 0 2.82-2.81V3.77A2.81 2.81 0 0 0 28.72 1" />
      <path d="M22.58 15.54a4 4 0 1 0-3.94-4.76H.44v1.5h18.2a4 4 0 0 0 3.94 3.26m0-6.53a2.52 2.52 0 1 1-2.52 2.52A2.52 2.52 0 0 1 22.58 9ZM16.18 18.88a3.07 3.07 0 1 0 1.49 0 3.84 3.84 0 0 0-3.81-3.48H.44v1.5h13.42a2.36 2.36 0 0 1 2.32 1.98m.82 1.39a1.57 1.57 0 1 1-1.56 1.56A1.57 1.57 0 0 1 17 20.27" />
    </g>
  </svg>
);

export default SvgLearning;
